(function () {
    "use strict";
    angular
        .module("common.services")
        .factory("webJobService", ["$http", webJobService]);
    function webJobService($http) {
        var webJobServiceFactory = {};
        var processAssignmentMapQueue = function () {
            return $http({ method: "POST", url: "/api/webJobs/process-map-queue" });
        };
        function processAssignmentMapQueueForUser() {
            return $http({ method: "POST", url: "/api/webJobs/process-map-queue-for-user" });
        }
        webJobServiceFactory.processAssignmentMapQueue = processAssignmentMapQueue;
        webJobServiceFactory.processAssignmentMapQueueForUser = processAssignmentMapQueueForUser;
        return webJobServiceFactory;
    }
}());
